import type { Locale } from 'antd/lib/locale'
import enUSAntd from 'antd/locale/en_US'
import ptBRAntd from 'antd/locale/pt_BR'

export const fallbackLng = 'en-US'
export const availableLanguages = ['en-US', 'pt-BR'] as const
export type AvailableLanguageType = (typeof availableLanguages)[number]

export const antdTranslationResources: Record<AvailableLanguageType, Locale> = {
  'en-US': enUSAntd,
  'pt-BR': ptBRAntd,
}
